import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { CheckInService } from '../services/check-ins.service';
import { CheckInQueueItem } from '../../model/classes/check-in-queue-item';
import { CheckInDetailDoorSelection } from '../../model/classes/check-in-detail-door-selection';
import { PickupDoorPayload } from '../../model/classes/pickup-door-payload';
import { NgForm } from '@angular/forms';
import { markAllFormFieldsAsTouched } from '@mt-ng2/common-functions';
import { CheckInTypes } from '../../model/CheckInTypes';
import { OfficeService } from '../../offices/services/office.service';

@Component({
    selector: 'check-in-door-selection-dialog',
    styles: [
        `
            .validator-msg {
                color: red;
            }
        `,
    ],
    templateUrl: './check-in-door-selection-dialog.component.html',
    standalone: false
})
export class CheckInDoorSelectionDialogComponent implements OnInit, OnChanges {
    customerId: number;
    doubleClickIsDisabled = false;
    checkInDetailDoorItems: CheckInDetailDoorSelection[] = [];
    gatePassId: string;
    checkInTypes = CheckInTypes;

    @Input('checkin') checkinQueueItem: CheckInQueueItem;
    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
    constructor(
        private notificationsService: NotificationsService,
        private checkInService: CheckInService,
        private officeService: OfficeService
    ) {}

    ngOnInit(): void {
        this.checkInDetailDoorItems = [];
        if (this.checkinQueueItem && this.checkinQueueItem !== null) {
            this.checkinQueueItem.CheckInQueueItemDetails.forEach((cd) => {
                const newDoorSelection: CheckInDetailDoorSelection = {
                    CheckInDetailId: cd.Id,
                    OfficeDoor: null,
                    OfficeDoors: [],
                    CustomerId: cd.CustomerId,
                    CustomerSchedulingAndDoorAssignment: cd.CustomerSchedulingAndDoorAssignment,
                    OrderNo: cd.OrderNo,
                };
                
                this.checkInDetailDoorItems.push(newDoorSelection);
                const officeId = cd.Office?.Id;
                if (cd.CustomerId && cd.CustomerSchedulingAndDoorAssignment && officeId) {
                    this.officeService.getOfficeDoorsByOffice(officeId).subscribe((answer) => {
                        newDoorSelection.OfficeDoors = answer;
                    });
                }
            });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.checkinQueueItem) {
            this.ngOnInit();
        }
    }

    formSubmitted(form: NgForm): void {
        if (form.invalid) {
            markAllFormFieldsAsTouched(form.form);
            return;
        }
        
        const pickupDoorPayload: PickupDoorPayload[] = this.checkInDetailDoorItems.map((c) => ({
            CheckinDetailId: c.CheckInDetailId,
            OfficeDoor: c.OfficeDoor,
            CustomerDoor: null,
        }));
        
        this.checkInService
            .notifyDriverWithPickUpDetails(this.checkinQueueItem.CheckInInfo.Id, pickupDoorPayload, this.gatePassId).subscribe(
                (answer) => {
                    if (String(answer) === 'true') {
                        this.notificationsService.success('Driver Notified');
                    } else {
                        this.notificationsService.error('Failed to notify driver');
                    }
                    this.close();
                },
                () => {
                    this.notificationsService.error('Notifying Driver Failed');
                    this.close();
                },
            );
    }

    close(): void {
        this.onClose.emit();
    }
}
